import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sitemap-history',
  templateUrl: './sitemap-history.component.html',
  styleUrls: ['./sitemap-history.component.css']
})
export class SitemapHistoryComponent {
  @Input() history: any[] = [];
  @Output() selected = new EventEmitter<any>();

  selectAudit(audit: any) {
    this.selected.emit(audit);
  }
}
